import { useState } from "react";
import "./TaskChatPanel.css"; // Import CSS file
const ChevronUp = () => (
    <svg width="16" height="16" viewBox="0 0 24 24">
      <path d="M12 8l-6 6h12z" fill="currentColor" />
    </svg>
  );

  const ChevronDown = () => (
    <svg width="16" height="16" viewBox="0 0 24 24">
      <path d="M12 16l6-6H6z" fill="currentColor" />
    </svg>
  );
  
  export default function TaskChatPanel(props) {
    const [expandedTask, setExpandedTask] = useState(null);
  
    const toggleTask = (taskId) => {
      setExpandedTask(expandedTask === taskId ? null : taskId);
    };
  
    return (
      <div className="container">
        {props.tasks.map((task) => (
          <div key={task.id} className="task">
            <button className="task-button" onClick={() => toggleTask(task.id)}>
              <span>{task.heading}</span>
              {expandedTask === task.id ? <ChevronUp /> : <ChevronDown />}
            </button>
  
            {expandedTask === task.id && (
              <div className="chat-list">
                
                  <ul>
                  {task.chats.map((chat, index) => (
                      <li onClick={()=>{props.loadconversation(task.id,chat)}} key={index}>{chat}</li>
                  ))}
              </ul>
               
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
  